import { render, staticRenderFns } from "./XOffset.vue?vue&type=template&id=23a11b28&"
import script from "./XOffset.vue?vue&type=script&lang=js&"
export * from "./XOffset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports